(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('PeriodeDeleteController',PeriodeDeleteController);

    PeriodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Periode'];

    function PeriodeDeleteController($uibModalInstance, entity, Periode) {
        var vm = this;

        vm.periode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Periode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
